import { useEffect, useMemo, useState } from 'react';

import type { IDropdownOption } from 'widgets/RatesChart';

export const useMonthDropdownData = (months: string[], changeMonth: (month: string) => void) => {
  const [curMonth, setCurMonth] = useState<IDropdownOption | null>(null);

  const monthsOptions = useMemo(
    () =>
      months.map((month) => ({
        label: new Date(month).toLocaleString('ru-RU', { month: 'long', year: 'numeric' }),
        value: month,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(months)],
  );

  const onMonthChange = (month: string) => {
    setCurMonth(monthsOptions.find((item) => item.value === month) || null);
    changeMonth(month);
  };

  useEffect(
    () => {
      const lastOption = monthsOptions[0];
      if (lastOption) {
        onMonthChange(lastOption.value);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(monthsOptions)],
  );

  return {
    monthsOptions,
    curMonth,
    onMonthChange,
  };
};
